import { MInput } from '@Components/Base';
import { useGetTenderMaterialsQuery } from '@Features/MaterialRequest/requests/TenderRequest/store/api/TenderRequestApiSlice';
import { useAppSelector } from '@Hooks/index';
import { getModalRecordKey } from '@Store/selectors/modalSelector';
import { useCallback, useMemo, useState } from 'react';
import { findTenderMaterialItemBySearchValue } from '@Features/MaterialRequest/requests/utils/finder';
import { TenderMaterial } from '@Types/api/form/tenderRequest/TenderMaterialResponse';
import styles from '../view-tab.module.css';
import MaterialTabItem from './MaterialTabItem';

const MaterialsTab: React.FC = () => {
  const [searchValue, setSearchValue] = useState<string>();
  const tenderId = useAppSelector(getModalRecordKey);
  const { data: materials } = useGetTenderMaterialsQuery(tenderId, {
    skip: !tenderId,
  });
  const [searchedMatItems, setSearchedMatItems] =
    useState<Array<TenderMaterial>>();

  const handleSearchMaterialItems = useCallback(
    (value: string) => {
      setSearchValue(value);
      if (materials) {
        const result = findTenderMaterialItemBySearchValue(materials, value);
        setSearchedMatItems(result);
      }
    },
    [materials]
  );

  const dataToDisplay = useMemo(() => {
    if (searchValue) {
      return searchedMatItems;
    }
    return materials;
  }, [materials, searchValue, searchedMatItems]);

  return (
    <div className={styles.viewTabMaterials}>
      <MInput
        className={styles.search}
        value={searchValue}
        searchInput
        placeholder="Search..."
        onChange={(event) => handleSearchMaterialItems(event.target.value)}
      />
      <div className={styles.container}>
        {dataToDisplay?.map((item, index) => (
          <MaterialTabItem
            materialDescription={item.materialDesc}
            index={item.materialCode}
            materialCode={item.materialCode}
            qty={item.reqQty}
            remarks={item.comments}
            unit={item.unitName}
            previousRate={item.prevRate}
            key={`_${item.materialCode + index}`}
          />
        ))}
      </div>
    </div>
  );
};

export default MaterialsTab;
